import defaultFormLocale from '@translations/locales/default-form-locale.json'

export type LocaleType = typeof defaultFormLocale

let Locale = defaultFormLocale

export const setLocale = (locale: LocaleType) => {
  Locale = locale
}

export const getLocale = () => {
  return Locale
}
